import React from 'react'
import { useSelector } from 'react-redux';
import BuildingsCustomRadio from './BuildingsCustomRadio/BuildingsCustomRadio';

function BuildingsCustomRadiogroup(props) {
  const {
    className, name, radios, selectedValue, onChange, disabled,
  } = props;
  const isCreatingNewDamageLayer = useSelector(state => state.newDamageLayer.isCreatingNewDamageLayer);

  return (
    <div className={`radiogroup ${className || ''}`}>
      { 
        radios.map((radio) => {
          return (
            <BuildingsCustomRadio 
              key={radio.value}
              name={name}
              label={radio.label}
              value={radio.value}
              checked={selectedValue === radio.value}
              onChange={e => onChange(e.target.value)}
              disabled={disabled}
              selectedValue={selectedValue}
              isCreatingNewDamageLayer={isCreatingNewDamageLayer}
            />
          );
        }) 
      }
    </div>
  );
}

export default BuildingsCustomRadiogroup